import styled from 'styled-components';

export const OwnerEditInfoContainer = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

export const PropertiesLink = styled.div`
  margin-top: 0.5rem;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
`;
